import React, { useEffect } from "react";
import {
  AboutArea,
  ConceptArea,
  ContactForm,
  MeritArea,
  TopArea,
} from "../components/contents";
import { FooterArea } from "../components/footer";
import { HeaderMenu } from "../components/header";
// import { useDispatch, useSelector } from "react-redux";
// import { getUserId, getUserName } from "../reducks/users/selectors";
// import { signOut } from "../reducks/users/operations";
// import { MiniButton } from "../components/UIkit";
// import { push } from "connected-react-router";

const Home = () => {
  // const dispatch = useDispatch();
  // const selector = useSelector((state) => state);
  // const uid = getUserId(selector);
  // const username = getUserName(selector);

  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <HeaderMenu />
      {/* <div className="responsive-meter">Responsive Meter</div> */}
      <TopArea />
      <ConceptArea />
      <AboutArea id="about" />
      <MeritArea id="merit" />
      <ContactForm id="contact" />
      <FooterArea />
      {/* ここより下は記事投稿するときに使う */}
      {/* <div className="common-section-container center">
        <div className="spacer-box--l"> </div>
        <MiniButton label="LOGIN" onClick={() => dispatch(push("/signin"))} />
        <MiniButton label="SIGNUP" onClick={() => dispatch(push("/signup"))} />
        <MiniButton label="LOGOUT" onClick={() => dispatch(signOut())} />
        <MiniButton label="投稿" onClick={() => dispatch(push("/post/edit"))} />
        <MiniButton
          label="投稿一覧"
          onClick={() => dispatch(push("/postslist"))}
        />
        <p>ユーザーID：{uid}</p>
        <p>ユーザー名：{username}</p>
      </div> */}
    </div>
  );
};

export default Home;
